import axios from 'axios';
import { getToken } from '../shared/src/services/user-info.service';

const mentoriaURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL as string;

let refreshingTokenPromise: Promise<string> | null = null;

const mentoriaApi = axios.create({
	baseURL: mentoriaURL,
});

mentoriaApi.interceptors.request.use(async (config: any) => {
	const token = getSessionToken();
	if (token && token !== "undefined" && !isTokenExpired(token)) {
		if (config.headers) {
			config.headers.Authorization = `Bearer ${token}`;
		}
	} else {
		// Si ya hay una promesa de refresco en curso, espera a que termine
		if (!refreshingTokenPromise) {
			refreshingTokenPromise = refreshToken().finally(() => {
				refreshingTokenPromise = null;
			});
		}
		const newToken = await refreshingTokenPromise;
		if (config.headers) {
			config.headers.Authorization = `Bearer ${newToken}`;
		}
		setSessionToken(newToken);
	}
	return config;
});
  
  function getSessionToken(): string | null {
	return sessionStorage.getItem('mentoria-token');
  }
  
  function setSessionToken(token: string): void {
	sessionStorage.setItem('mentoria-token', token);
  }
  
  function isTokenExpired(token: string): boolean {
	const decodedToken = JSON.parse(atob(token.split('.')[1]));
	const expiresAt = decodedToken.exp * 1000; // convert to milliseconds
	return expiresAt < Date.now();
  }
  
	async function refreshToken(): Promise<string> {
		const uid = sessionStorage.getItem('mentoria-uid');
		if (!uid || typeof uid !== 'string' || uid.trim() === '') {
			console.error('refreshToken: UID inválido o no disponible', { uid });
			sessionStorage.removeItem('mentoria-token');
			throw new Error('No token available: UID missing or invalid');
		}
		try {
			// Timeout para evitar promesas colgadas
			const timeoutPromise = new Promise<string>((resolve, reject) =>
				setTimeout(() => reject(new Error('Token refresh timed out')), 8000)
			);
			const tokenPromise = getToken(uid);
			const response = await Promise.race([tokenPromise, timeoutPromise]);
			if (!response || typeof response !== 'string' || response.trim() === '') {
				console.error('refreshToken: Token recibido inválido', { response });
				sessionStorage.removeItem('mentoria-token');
				throw new Error('Failed to refresh token: Invalid token received');
			}
			return response;
		} catch (error: any) {
			console.error('refreshToken: Error al refrescar token', error);
			sessionStorage.removeItem('mentoria-token');
			if (error && error.message) {
				throw new Error(`Failed to refresh token: ${error.message}`);
			}
			throw new Error('Failed to refresh token: Unknown error');
		}
	}
  
	export default mentoriaApi;
	export { refreshToken };